/* eslint-disable filenames/match-regex */
import axiosInstance from "./global-instance";
import { b2cMasterDataApi } from "../constants/url-constants";
import createScopedApi from "./createScopedApi";
const BASE_API_URL = `${b2cMasterDataApi()}/`;
export default createScopedApi(BASE_API_URL, axiosInstance);
